module.exports = __webpack_public_path__ + "img/github.ba6edc51.png";